import { useEffect, useState } from 'react';
import axiosInstance from '../utility/axiosInstance';

export interface CapabilityResource {
  type: string;
  actions: string[];
  note?: string;
}

// Module-level cache - the action catalog is static for the app's lifetime, so fetch once.
let cache: CapabilityResource[] | null = null;

/**
 * Fetches the live scope catalog from GET /v1/capabilities (runs unauthenticated, so it
 * works before the user has any key). Feeds the advanced scope picker.
 */
export function useCapabilities() {
  const [resources, setResources] = useState<CapabilityResource[]>(cache ?? []);
  const [loading, setLoading] = useState<boolean>(!cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cache) return;
    let active = true;
    axiosInstance
      .get('/v1/capabilities')
      .then((res) => {
        if (!active) return;
        const data: CapabilityResource[] = Array.isArray(res.data?.resources) ? res.data.resources : [];
        cache = data;
        setResources(data);
      })
      .catch(() => {
        if (active) setError('Failed to load the scope catalog.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { resources, loading, error };
}
